<template>
  <div>
    <h1>Investor Selection</h1>
    <img v-if="!is_premium && is_load" src="/images/investors_preview.png?t=1" style="width:100%;max-width:1280px;display:block;" />
    <p v-if="is_premium && !investors.length">Please wait, Investors are loading ...</p>
    <p style="margin-bottom:20px;" v-if="is_premium && investors.length && is_premium_investors">Please find below the list of suitable and pre-qualified investors for your offering. <br />
      You can uncheck any of the investors below if you already have an existing relationship with them or if you don't want to approach them. <br />Once you are happy with the list, please make sure to click on the button “CONFIRM SELECTION” below.</p>
    <p style="margin-bottom:20px;" v-if="is_premium && investors.length && !is_premium_investors">The final investor list is being compiled for you right now. After that you will have the opportunity to deactivate any existing relationships and confirm the selection.</p>
    <div v-if="is_premium && is_premium_investors && questionnaire_step<4 && is_load"><i>Please complete the <a href="/account/questionnaire">questionnaire</a> first.</i></div>
    <div class="pta-investor-selection" v-if="is_premium && is_premium_investors && investors.length && questionnaire_step>3">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <th></th>
          <th>Organisation</th>
       <!--   <th>Contact&nbsp;Person</th>  -->
          <th>Investor&nbsp;Type</th>
          <th>Preferred Asset Class</th>
          <th>Preferred Geographic Area</th>
        </tr>
        <tr v-if="!investors">
          <td colspan="6" align="center">
            Data is loading ...
          </td>
        </tr>
        <tr v-for="investor in investors" v-if="investors && investor.name">
          <td valign="top"><input :disabled="is_confirmed" type="checkbox" :value="investor.id" @click="updateInvestorStatus(investor)" :checked="investor.pivot.is_deactive==2?false:true" /></td>
         <td valign="top" v-html="investor.name"></td>
          <!--   <td valign="top" v-html="investor.contact_person"></td> -->
            <td valign="top">
              <span v-for="investor_type in investor.investor_types">{{investor_type}}</span>
            </td>
            <td valign="top">
              <span v-for="asset_class in investor.asset_classes">{{asset_class}}</span>
            </td>
            <td valign="top">
              <span v-for="geo in investor.geos">{{geo}}</span>
            </td>
          </tr>
        </table>
      </div>
      <a href="#" v-if="is_premium && investors.length && is_premium_investors" class="pta-button" @click.prevent="confirmSelection" :class="is_confirmed?'pta-button-inactive':''">CONFIRM SELECTION</a>
      <!-- <div class="pta-investor-selection">
         <table cellpadding="0" cellspacing="0">
           <tr>
             <th></th>
             <th>Organization</th>
             <th>Contact Person</th>
             <th>Investor Type</th>
             <th>Preferred Asset Class</th>
             <th>Preferred Geographic Area</th>
           </tr>
           <tr>
             <td></td>
             <td>******</td>
             <td>******</td>
             <td><span>Real Estate Investment</span></td>
             <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
             <td><span>Canada</span><span>Germany</span><span>UK</span></td>
           </tr>
           <tr>
             <td></td>
             <td>******</td>
             <td>******</td>
             <td><span>Real Estate Investment</span></td>
             <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
             <td><span>Canada</span><span>Germany</span><span>UK</span></td>
           </tr>
           <tr>
             <td></td>
             <td>******</td>
             <td>******</td>
             <td><span>Real Estate Investment</span></td>
             <td><span>Buyout</span><span>Real Estate Opprtunities</span></td>
             <td><span>Canada</span><span>Germany</span><span>UK</span></td>
           </tr>
         </table>
       </div>-->
  </div>
</template>
<script>
export default {
  components: {},
  mounted(){
    this.getQuestionnaire();
  },
  methods: {
    prerequisite(){
      axios.get('/api/user/profile/questionnaire/pre-requisite')
          .then(response => response.data)
          .then(response => {
            this.investors = response.investors;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    getQuestionnaire(){
      axios.get('/api/user/profile/questionnaire')
          .then(response => response.data)
          .then(response => {
            this.is_premium     = response.user.profile.is_premium;
            this.is_premium_investors     = response.user.profile.is_premium_investors;
            this.questionnaire_step      = response.user.profile.questionnaire_step;
            if(response.user.profile.is_confirmed==1){
              this.is_confirmed   = true;
            }else{
              this.is_confirmed   = false;
            }
            this.is_load = true;
            if(this.is_premium) {
              this.getInvestors();
            }
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    getInvestors(){
      axios.get('/api/investors')
          .then(response => response.data)
          .then(response => {
            this.investors = response;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    updateInvestorStatus(investor){
     //  investor.id, investor.pivot.is_deactive


      if(investor.pivot.is_deactive==1){
        investor.pivot.is_deactive = 2;
      }else{
        investor.pivot.is_deactive = 1;
      }

      axios.get('/api/investors/'+investor.id+'/user-status/'+investor.pivot.is_deactive)
          .then(response => response.data)
          .then(response => {

          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    confirmSelection(){
      if(!this.is_confirmed) {
        axios.get('/api/investors/confirm-selection')
            .then(response => response.data)
            .then(response => {
              this.is_confirmed = true;
            })
            .catch(error => {
              helper.showDataErrorMsg(error)
            });
      }
    },
  },
  data() {
    return {
      investors: '',
      is_premium: false,
      is_premium_investors: false,
      is_load: false,
      is_confirmed: false,
      questionnaire_step: 0
    }
  },
  computed: {

  },
  filters: {

  },
}
</script>